<template>
    <section>
        <el-tabs type="border-card" class="border-card">
            <el-tab-pane label="国家">
                <AreaManage></AreaManage>
            </el-tab-pane>
            <el-tab-pane label="语言">
                <LanguageManage></LanguageManage>
            </el-tab-pane>
            <el-tab-pane label="白名单">
                <WhiteList></WhiteList>
            </el-tab-pane>
        </el-tabs>
    </section>
</template>
<script>
    import AreaManage from "./AreaManage.vue"
    import LanguageManage from "./LanguageManage.vue"
    import WhiteList from "./WhiteList.vue"
    export default {
        components: {
            AreaManage,
            LanguageManage,
            WhiteList,
        },
        data() {
            return {}
        },
        methods: {

        }
    }
</script>


// WEBPACK FOOTER //
// src/components/area/Manage.vue